import { createSlice } from '@reduxjs/toolkit'
import { CompanyPlanningRecord } from '@leadgen/models/client'
import authActions from '../auth/actions'
import actions from './actions'

export interface CompanyPlanningRecordState {
  companyPlanningRecord: CompanyPlanningRecord | undefined
  error?: string
  status: 'initial' | 'idle' | 'loading' | 'loading-more' | 'failed'
}

export const initialState: CompanyPlanningRecordState = {
  companyPlanningRecord: undefined,
  status: 'initial',
}

export const companyPlanningRecordSlice = createSlice({
  name: 'companyPlanningRecord',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(authActions.loggedOut.type, () => {
        return initialState
      })
      .addCase(actions.loadCompanyPlanningRecord.pending, state => {
        state.status = 'loading'
      })
      .addCase(actions.loadCompanyPlanningRecord.fulfilled, (state, action) => {
        state.status = 'idle'
        state.companyPlanningRecord = action.payload.data
        state.error = undefined
      })
      .addCase(actions.loadCompanyPlanningRecord.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message
      })
      .addCase(actions.updateCompanyPlanningRecord, (state, action) => {
        state.companyPlanningRecord = action.payload
      })
  },
})

export default companyPlanningRecordSlice
